window.addEventListener('DOMContentLoaded', (event) => {
    jQuery('.tabanimationcontainer').animate({
        height: (jQuery('.tabscontainer').height() + 100) + 'px'
    }, 100);
});


// jQuery("#selectoption").click(function () {
//     console.log("option clicked: " + this.id);
//     change_tab(this, this.id);
// });

jQuery('#selectoption').change(function() {

   var id = jQuery('option:selected', this).attr('id');
   //console.log("option clicked: " + id);
   change_tab(jQuery(this), id);
});


jQuery('.taboption').click(function(event) {
    //console.log("tab clicked");
    var tabid = jQuery(event.target).attr('id')
    change_tab(event, tabid);
});

function change_tab(event, tabid){
    //console.log('running tab change event');
if (jQuery(event.target).hasClass('activetab')) {
    console.log("has activetab..");

} else {
    jQuery('.activetab').removeClass('activetab');
    jQuery(event.target).addClass('activetab');
    jQuery('.tabanimationcontainer').animate({
        left: '-50px'
    }, 200);
    jQuery('.tabcontainer').animate({
        opacity: '0'
    }, 200, function() {
        jQuery('.tabcontainer').hide();
        jQuery('.' + tabid).show();
        console.log("show: " + '.' + tabid + "  object: " + jQuery('.' + tabid))


    });
    // jQuery('.tabcontainer').hide();

    jQuery('.tabanimationcontainer').animate({
        left: '50px'
    }, 0);
    jQuery('.' + tabid).animate({
        opacity: '1'
    }, 200);
    jQuery('.tabanimationcontainer').animate({
        left: '0px'
    }, 200);


    setTimeout(function() {

        jQuery('.tabanimationcontainer').animate({
            height: (jQuery('.tabscontainer').height() + 100) + 'px'
        }, 400);
    }, 250);


}
}